<template>
    <div class="gold-order-layer">
        <div class="mask" :class="isShow?'mask-show':'mask-hide'" @click="layerHide"></div>
        <div class="gold-order-box abs-mm" :class="isShow?'mask-show':'mask-hide'">
            <div class="copy-img"></div>
            <div class="gold-order-title">金口令已复制</div>
            <div class="gold-subtitle">{{subTitle}}</div>
            <a class="gold-jump-btn" @click="copy" clstag="A05R|clk_share_copy_fx">
                <span>去</span><i class="wxIcon"></i><span>微信粘贴给好友</span>
            </a>
            <div class="gold-close-btn"></div>
        </div>
    </div>
</template>

<script>
    import proHub from './../scripts/proHub';
    import Global from './../scripts/Global';


    export default {
        data() {
            return {
                isShow: true,
                subTitle: Global.goldCopySuccessText,
                order: Global.goldCode
            }
        },
        mounted() {
            this.copyCode();
            proHub.get('toShare', {
                shareUuid: Global.inviteId, riskDeviceInfo: Global.riskDeviceInfo,
                environment: Global.currentSystem
            }, (e) => {
                if (e.code == '0000') {
                    this.subTitle = Global.goldCopySuccessText;
                    this.order = Global.goldCode;
                    this.copyCode();
                }
            })
        },
        methods: {
            layerHide() {
                this.isShow = false;
                setTimeout(() => {
                    this.$emit('layer-hide');
                }, 300)
            },
            copyCode() {
                this.$clipboard(Global.goldCode);
            },
            copy() {
                this.copyCode();

                this.$nextTick(() => {
                    if (Global.currentSystem == 'wx') {
                        this.layerHide();
                    } else {
                        window.location.href = 'weixin://'
                    }
                })
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">
    .gold-order-layer {position: fixed;left: 0;top: 0;width: 100%;height: 100%; z-index: 30;
        .mask {position: absolute;left: 0;top: 0;bottom: 0;right: 0;margin: auto;width: 100%;height: 100%;background: rgba(0, 0, 0, 0.8);}
        .mask-show {animation: maskShow 0.3s 1 ease-out both;}
        .mask-hide {animation: maskHide 0.3s 1 ease-out both;}
        .gold-order-box {width: 2.7rem;padding: 0.3rem 0;background-color: #fff;border-radius: 0.06rem;}
        .copy-img {position: absolute;right: 0;top: 0;width: 0.78rem;height: 0.61rem;background-image: url('#{$path}/dialog/copy-img.png');@include singleBg;}
        .gold-order-title {font-size: 0.18rem;color: #333;font-weight: bold;}
        .gold-subtitle {margin: 0 auto;margin-top: 0.05rem;max-width: 2.3rem;text-align: center;}
        .gold-jump-btn {width: 2.38rem;height: 0.42rem;border-radius: 0.5rem;background-color: #07c160;display: flex;justify-content: center;align-items: center;margin: 0 auto;color: #fff;margin-top: 0.2rem;}
        .wxIcon {width: 0.25rem;height: 0.25rem;background-image: url('#{$path}/dialog/wx-icon.png');@include singleBg;margin: 0 0.05rem;}
        .gold-close-btn {position: absolute;right: 0;top: -0.4rem;width: 0.25rem;height: 0.25rem;background-image: url('#{$path}/dialog/close-btn.png');@include singleBg;pointer-events: none;}
        }
</style>